import { createAsyncThunk } from "@reduxjs/toolkit";
import { EndPoint } from "../../../common/constants";
import { showAlert } from "../../../common/constants/alert";
import { getApiCall } from "../../../common/constants/api";
import { ResponseCode } from "../../../common/constants/responseCode";
import { setLoading } from "../../../redux/global.slice";

export const getUserProfile = createAsyncThunk(
  "get_api/user_profile",
  async (_, { fulfillWithValue }) => {
    try {
      const response = await getApiCall(EndPoint.userProfile, "");

      if (response && response.data) {
        const { data, statusCode, messages } = response.data;

        if (statusCode === ResponseCode.SUCCESS) {
          return fulfillWithValue(data);
        } else {
          showAlert(2, messages[0]);
        }
      }
    } catch (e) {}
  },
);

export const getUserOrganizations = createAsyncThunk(
  "get_api/user_organizations",
  async (_, { fulfillWithValue, dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await getApiCall(EndPoint.userOrganizations, "");

      if (response && response.data) {
        const { data, statusCode, messages } = response.data;
        if (statusCode === ResponseCode.SUCCESS) {
          dispatch(setLoading(false));
          if (data.length === 0)
            showAlert(
              2,
              "No organizations assigned for this user. Please contact admin.",
            );
          return fulfillWithValue(data);
        } else {
          showAlert(2, messages[0]);
        }
      }
      dispatch(setLoading(false));
    } catch (e) {
      dispatch(setLoading(false));
    }
  },
);

export const getUserApps = createAsyncThunk(
  "get_api/user_apps",
  async ({ orgId }: { orgId: number }, { fulfillWithValue, dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await getApiCall(EndPoint.userApps, `/${orgId}`);

      if (response && response.data) {
        const { data, statusCode, messages } = response.data;

        if (statusCode === ResponseCode.SUCCESS) {
          dispatch(setLoading(false));
          if (data?.length === 0)
            showAlert(2, "No Applications available for this organization. Please contact Admin.");
          return fulfillWithValue(data);
        } else {
          showAlert(2, messages[0]);
        }
      }
      dispatch(setLoading(false));
    } catch (e) {
      dispatch(setLoading(false));
    }
  },
);

export const getUserAppRedirect = createAsyncThunk(
  "get_api/user_app_direct",
  async (
    { appId, successFn }: { appId: number; successFn: any },
    { fulfillWithValue, dispatch },
  ) => {
    dispatch(setLoading(true));
    try {
      const response = await getApiCall(EndPoint.userAppRedirect, `/${appId}`);

      if (response && response.data) {
        const { data, statusCode, messages } = response.data;

        if (statusCode === ResponseCode.SUCCESS) {
          dispatch(setLoading(false));
          if (successFn) successFn(data);
          return fulfillWithValue(data);
        } else {
          showAlert(2, messages[0]);
        }
      }
      dispatch(setLoading(false));
    } catch (e) {
      dispatch(setLoading(false));
    }
  },
);
